export function isEntityId(value) {
    return value.length >= 24 && /^[0-9a-f]+$/i.test(value);
}
